import React, {useState} from 'react'
import style from './careers.module.css'
import { careerData } from './assets/data'
import { emaiService } from '../../api/emailApi'


const CareersPage = () => {
    const [showApplicationForm,
        setShowApplicationForm] = useState(false)
    const [formData,
        setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: '',
        experience: '',
        education: '',
        cv: null,
        coverLetter: '',
        linkedIn: '',
        portfolio: ''
    })

    const handleChange = (e) => {
        const {name, value} = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            cv: e.target.files[0]
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        console.log('Candidature envoyée:', formData)
        // Logique d'envoi

        const fd = new FormData(e.currentTarget)

        console.log("Les données finales ", fd)
        const resp = await emaiService.joinUs(fd)

        console.log("The finale verision  ", resp)
    }

    // toutes les données de l'extérieur
    const {profiles, disciplines, benefits, values} = careerData

    return (
        <div className={style.mainCareers}>

            {/* Hero Section with Background */}
            <div className={style.heroSection}>
                <div className={style.heroOverlay}></div>
                <div className={style.containerHead}>
                    <h1>Travaillez avec Nous</h1>
                    <p className={style.subtitle}>
                        Rejoignez une équipe passionnée qui façonne l'avenir
                    </p>
                    <p className={style.description}>
                        Chez Get-Conseil, nous croyons au potentiel de chaque talent. Que vous soyez
                        jeune diplômé ou expert confirmé, nous vous offrons l'opportunité de créer un
                        impact positif dès le premier jour.
                    </p>
                    <button className={style.applyBtn} onClick={() => setShowApplicationForm(true)}>
                        Postuler Maintenant
                    </button>
                </div>
            </div>

            {/* Why Join Us */}
            <div className={style.whySection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Pourquoi Nous Rejoindre ?</h2>
                    <p className={style.sectionIntro}>
                        Get-Conseil offre bien plus qu'un emploi : c'est une opportunité de
                        développement, d'apprentissage et d'impact sur l'économie de notre région.
                    </p>
                    <div className={style.benefitsGrid}>
                        {benefits.map((benefit, index) => (
                            <div key={index} className={style.benefitCard}>
                                <div className={style.benefitIcon}>{benefit.icon}</div>
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Profiles Section */}
            <div className={style.profilesSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Nous Recherchons Tous Types de Talents</h2>
                    <p className={style.sectionIntro}>
                        Nous accueillons des candidatures spontanées de profils variés, capables
                        d'apporter compétences, expertise et solutions innovantes.
                    </p>
                    <div className={style.profilesGrid}>
                        {profiles.map((profile, index) => (
                            <div key={index} className={style.profileCard}>
                                <div className={style.profileIcon}>{profile.icon}</div>
                                <h3>{profile.title}</h3>
                                <p className={style.profileDescription}>{profile.description}</p>
                                <p className={style.profileDetails}>{profile.details}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Young Graduates Section */}
            <div className={style.graduatesSection}>
                <div className={style.graduatesOverlay}></div>
                <div className={style.sectionContainer}>
                    <div className={style.graduatesContent}>
                        <div className={style.graduatesText}>
                            <h2>Carrières pour Jeunes Diplômés</h2>
                            <p className={style.graduatesSubtitle}>
                                Créez un impact dès le départ
                            </p>
                            <p>
                                Get-Conseil forme et recrute des jeunes diplômés dans diverses disciplines.
                                Découvrez des missions à impact positif pour commencer votre carrière en
                                agissant au quotidien sur des projets concrets et enrichissants.
                            </p>
                            <p className={style.highlight}>
                                Nous offrons des opportunités pour juniors et stagiaires avec un accompagnement
                                personnalisé et des parcours d'intégration structurés.
                            </p>
                        </div>
                        <div className={style.disciplinesGrid}>
                            <h3>Disciplines Recherchées</h3>
                            <div className={style.disciplinesList}>
                                {disciplines.map((discipline, index) => (
                                    <div key={index} className={style.disciplineTag}>
                                        <span className={style.disciplineIcon}>{discipline.icon}</span>
                                        {discipline.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Values Section */}
            <div className={style.valuesSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Ce Que Nous Attendons de Vous</h2>
                    <p className={style.sectionIntro}>
                        Au-delà des compétences techniques, nous recherchons des personnes qui partagent
                        nos valeurs et notre vision.
                    </p>
                    <div className={style.valuesGrid}>
                        {values.map((value, index) => (
                            <div key={index} className={style.valueCard}>
                                <div className={style.valueNumber}>{index + 1}</div>
                                <h3>{value.title}</h3>
                                <p>{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Integration Process */}
            <div className={style.processSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Votre Parcours d'Intégration</h2>
                    <div className={style.processTimeline}>
                        <div className={style.processStep}>
                            <div className={style.stepNumber}>1</div>
                            <h3>Candidature</h3>
                            <p>Soumettez votre CV et lettre de motivation</p>
                        </div>
                        <div className={style.processStep}>
                            <div className={style.stepNumber}>2</div>
                            <h3>Entretien</h3>
                            <p>Échange avec notre équipe RH et managers</p>
                        </div>
                        <div className={style.processStep}>
                            <div className={style.stepNumber}>3</div>
                            <h3>Évaluation</h3>
                            <p>Tests techniques et mise en situation</p>
                        </div>
                        <div className={style.processStep}>
                            <div className={style.stepNumber}>4</div>
                            <h3>Onboarding</h3>
                            <p>Formation et intégration personnalisée</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Application CTA */}
            <div className={style.ctaSection}>
                <div className={style.ctaContainer}>
                    <h2>Prêt à Nous Rejoindre ?</h2>
                    <p>
                        Postulez spontanément et faites partie de l'équipe qui transforme le paysage
                        économique de l'Afrique centrale
                    </p>
                    <button
                        className={style.primaryBtn}
                        onClick={() => setShowApplicationForm(true)}>
                        Envoyer Ma Candidature
                    </button>
                </div>
            </div>

            {/* Application Form Modal */}
            {showApplicationForm && (
                <div
                    className={style.modalOverlay}
                    onClick={() => setShowApplicationForm(false)}>
                    <div className={style.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button
                            className={style.closeBtn}
                            onClick={() => setShowApplicationForm(false)}>✕</button>

                        <div className={style.modalHeader}>
                            <h2>Postuler à Get-Conseil</h2>
                            <p>Remplissez ce formulaire pour soumettre votre candidature spontanée</p>
                        </div>

                        <form onSubmit={handleSubmit} className={style.applicationForm}>
                            <div className={style.formRow}>
                                <div className={style.formGroup}>
                                    <label htmlFor="firstName">Prénom *</label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required/>
                                </div>
                                <div className={style.formGroup}>
                                    <label htmlFor="lastName">Nom *</label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required/>
                                </div>
                            </div>

                            <div className={style.formRow}>
                                <div className={style.formGroup}>
                                    <label htmlFor="email">Email *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required/>
                                </div>
                                <div className={style.formGroup}>
                                    <label htmlFor="phone">Téléphone *</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required/>
                                </div>
                            </div>

                            <div className={style.formGroup}>
                                <label htmlFor="position">Poste Visé *</label>
                                <select
                                    id="position"
                                    name="position"
                                    value={formData.position}
                                    onChange={handleChange}
                                    required>
                                    <option value="">Sélectionnez un poste</option>
                                    <option value="junior">Junior / Jeune Diplômé</option>
                                    <option value="stagiaire">Stagiaire / Alternant</option>
                                    <option value="consultant">Consultant</option>
                                    <option value="expert">Expert / Senior</option>
                                    <option value="spontanee">Candidature Spontanée</option>
                                </select>
                            </div>

                            <div className={style.formRow}>
                                <div className={style.formGroup}>
                                    <label htmlFor="experience">Années d'Expérience</label>
                                    <select
                                        id="experience"
                                        name="experience"
                                        value={formData.experience}
                                        onChange={handleChange}>
                                        <option value="">Sélectionnez</option>
                                        <option value="0-1">0-1 an</option>
                                        <option value="1-3">1-3 ans</option>
                                        <option value="3-5">3-5 ans</option>
                                        <option value="5+">5+ ans</option>
                                    </select>
                                </div>
                                <div className={style.formGroup}>
                                    <label htmlFor="education">Niveau d'Études *</label>
                                    <select
                                        id="education"
                                        name="education"
                                        value={formData.education}
                                        onChange={handleChange}
                                        required>
                                        <option value="">Sélectionnez</option>
                                        <option value="bac+2">Bac+2</option>
                                        <option value="bac+3">Licence (Bac+3)</option>
                                        <option value="bac+5">Master (Bac+5)</option>
                                        <option value="doctorat">Doctorat</option>
                                    </select>
                                </div>
                            </div>

                            <div className={style.formGroup}>
                                <label htmlFor="cv">CV (PDF) *</label>
                                <input
                                    type="file"
                                    id="cv"
                                    name="cv"
                                    accept=".pdf"
                                    onChange={handleFileChange}
                                    required/>
                            </div>

                            <div className={style.formGroup}>
                                <label htmlFor="linkedIn">Profil LinkedIn</label>
                                <input
                                    type="url"
                                    id="linkedIn"
                                    name="linkedIn"
                                    value={formData.linkedIn}
                                    onChange={handleChange}
                                    placeholder="https://linkedin.com/in/votreprofil"/>
                            </div>

                            <div className={style.formGroup}>
                                <label htmlFor="portfolio">Portfolio / Site Web</label>
                                <input
                                    type="url"
                                    id="portfolio"
                                    name="portfolio"
                                    value={formData.portfolio}
                                    onChange={handleChange}
                                    placeholder="https://votreportfolio.com"/>
                            </div>

                            <div className={style.formGroup}>
                                <label htmlFor="coverLetter">Lettre de Motivation *</label>
                                <textarea
                                    id="coverLetter"
                                    name="coverLetter"
                                    value={formData.coverLetter}
                                    onChange={handleChange}
                                    required
                                    rows="8"
                                    placeholder="Parlez-nous de votre motivation, vos compétences et ce que vous pouvez apporter à Get-Conseil..."></textarea>
                            </div>

                            <button type="submit" className={style.submitBtn}>
                                Envoyer ma Candidature
                            </button>
                        </form>
                    </div>
                </div>
            )}

        </div>
    )
}

export default CareersPage